import { render, staticRenderFns } from "./multiline_input.vue?vue&type=template&id=08fa7546&scoped=true&"
import script from "./multiline_input.vue?vue&type=script&lang=js&"
export * from "./multiline_input.vue?vue&type=script&lang=js&"
import style0 from "./multiline_input.vue?vue&type=style&index=0&id=08fa7546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa7546",
  null
  
)

export default component.exports